export default "__VITE_ASSET__a1575cb3__"